import { useNavigate } from "react-router-dom"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { PageHeader } from "../../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../../shared/components/pageHeader/PageHeaderApi"
import { useApiMutation } from "../../../../../../core/api/useApiMutation"
import {
    COMPANY_ADMIN_DATA_IMPORT_ID_CARDS_RESULT_ROUTE,
    COMPANY_ADMIN_ROUTE,
} from "../../../../../../constants/routes"
import { useCurrentCompany } from "../../../../hooks/useCurrentCompany"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../../shared/components/links/StandardBreadcrumbs"
import { ImportIdCardsForm } from "../components/ImportIdCardsForm"
import { importIdCards } from "../idCardsApi"

export function CompanyIdCards() {
    const { companyId } = useCurrentCompany()
    const navigate = useNavigate()
    const { mutate: callImportIdCards } = useApiMutation(importIdCards, {
        async onSuccess(_, data) {
            navigate(COMPANY_ADMIN_DATA_IMPORT_ID_CARDS_RESULT_ROUTE, {
                state: { importResult: data.importResult },
            })
        },
    })

    return (
        <>
            <LocalizedStrict id="company-data-import-id-cards-title" attrs={{ title: true }}>
                <PageHeader page={Page.COMPANY_ADMINS_DATA_IMPORT_ID_CARDS} title="Import ID cards">
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="company-nav-item-home">
                            <BreadcrumbLink to={COMPANY_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="company-nav-item-data-import">
                            <Breadcrumb>Data import</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="company-nav-item-id-cards">
                            <Breadcrumb>ID cards</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>
            <ImportIdCardsForm
                onSubmit={(data) => {
                    callImportIdCards({ importData: data, companyId: companyId })
                }}
            />
        </>
    )
}
